import React from 'react';
import {UserIcon,BuildingOffice2Icon,BanknotesIcon} from '@heroicons/react/24/outline'
import AccoutTypeItem from '../../components/AccoutTypeItem';
import { AccountType } from '../../models';
import { useNavigate } from 'react-router-dom';
import { useContextState } from '../../context/Context';

const AccountTypes = () => {
  const { accountCTX } = useContextState();
  const { setAccountType } = accountCTX
  const navigate =useNavigate()
  const selectAccountType=(accountType:AccountType)=>{
    setAccountType(accountType);
    navigate('/login');
  }
  return (
    <div className='h-full flex flex-col py-8 gap-8 md:flex-row md:px-[10%] md:py-[7%]'>
     <AccoutTypeItem  Icon={UserIcon} title="Compte Client"  
     onSelectAccountType={()=>selectAccountType(AccountType.CLIENT)}
     />
     <AccoutTypeItem Icon={BanknotesIcon} title="Compte Business"
       onSelectAccountType={()=>selectAccountType(AccountType.BUSINESS)}/>
     <AccoutTypeItem Icon={BuildingOffice2Icon} title="Compte Kiosque"
       onSelectAccountType={()=>selectAccountType(AccountType.kIOSQUE)}/>
    </div>
  )
}

export default AccountTypes